import React from 'react';

const Loader = () => {
  return (
    <img
      src="/content/images/loader/loading.gif"
      alt="loader"
      className="searchBarLoader"
      role="progressbar"
    />
  );
};
export default Loader;
